import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { formatISO } from "date-fns";
import tblarrrow from "../../assets/images/tblarrrow.svg";
// image import
import date from "../../assets/images/date.svg";
import i1 from "../../assets/images/i1.svg";
import i2 from "../../assets/images/i2.svg";
import i3 from "../../assets/images/i3.svg";
import addicon from "../../assets/images/addicon.svg";
import icon4 from "../../assets/images/icon4.svg";
import comonicon from "../../assets/images/comonicon.svg";
// icon import
import { MdEdit } from "react-icons/md";
import { FaLocationArrow } from "react-icons/fa6";
import { BsGraphUpArrow } from "react-icons/bs";
import { BsCurrencyDollar } from "react-icons/bs";
import { RiLineChartFill } from "react-icons/ri";
import { RiSketching } from "react-icons/ri";
import { PiChartLineBold } from "react-icons/pi";
import { BiLineChartDown } from "react-icons/bi";
import { GiChart, GiConsoleController } from "react-icons/gi";
import { IoTrophyOutline } from "react-icons/io5";
import { TfiPieChart } from "react-icons/tfi";
import { GoQuestion } from "react-icons/go";
import axios from "axios";
// import {
//   BarElement,
//   CategoryScale,
//   Legend,
//   LinearScale,
//   Title,
//   Tooltip,
//   Chart as chartJS,
// } from "chart.js";
import LineChart from "../LineChart";
import Page2 from "../Page2";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectedAccount,
  UserDetails,
  getBalance,
  Allbalance,
  RiskBalance,
  CalculationBalance,
  addAccountStatus,
  storeRiskLevel1,
  storeRiskLevel2,
  storeRiskLevel3,
  SelectedAsset,
  cancelRiskLevelData,
  submitRisk_level_id,
  Account_Priority,
  selectAccount,
} from "../../redux/userSlice";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

// import components
import SelectedAccountComponent from "./SelectedAccount";
import LoaderModal from "../ModalLoader/LoaderModal";
import ModalFrom from "./ModalFrom";
import RiskMangementtable from "./RiskMangementtable";
import SelectedAssetsComponent from "./SelectedAssetsComponent";
import DynamicCl from "../DynamicCl/DynamicCl";
import AssetCalcualtion from "./AssetCalcualtion";

// chartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

const Dashboard = () => {
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const dispatch = useDispatch();

  const userDetails = useSelector(UserDetails);
  const selectedAccountDetails = useSelector(SelectedAccount);
  const getBalanceDetails = useSelector(Allbalance);
  const riskBalanceDetails = useSelector(RiskBalance);
  const CalculationResponse = useSelector(CalculationBalance);
  const [currentRisk, setCurrentRisk] = useState("Aggressive");
  const [coefficient, setCoefficient] = useState("Aggressive");
  const [Accountid, setAccountid] = useState("");
  const selectedAssetDetails = useSelector(SelectedAsset);

  const handleChangeRisk = (event) => {
    setCurrentRisk(event.target.value);
  };
  const handleChangecoefficient = (event) => {
    setCoefficient(event.target.value);
  };

  const accountPriority = useSelector(Account_Priority);
  const token = userDetails?.token;

  // for loading modal ==>
  const [showModal, setShowModal] = useState(false);

  const [riskManagementModal, setRiskManagementModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  // console.log("close modal",closeModal);
  

  // useEffect(() => {

  useEffect(() => {
    showRiskLevelCalculation();
  }, [selectedAccountDetails?.accountId]);

  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    showAccounts_dashboard();
  }, []);

  const showAccounts_dashboard = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-all-source-account/${userDetails.id}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("account show in dashboard",response.data.response[0].sourceAccountId)
      if (response.data.response[0].sourceAccountId) {
        setAccountid(response.data.response[0].sourceAccountId);
        AccountStatusforprotectedroutes(
          response.data.response[0].sourceAccountId
        );
      }
      setAccounts(response.data.response);
      if (response.data && !selectedAccountDetails) {
        dispatch(
          selectAccount({
            account: {
              accountId: response.data.response[0].sourceAccountId,
              accountName: response.data.response[0].accountName,
              accountStatus: response.data.response[0].status,
            },
          })
        );
      }

      // Handle response data as needed
    } catch (error) {
      console.error("Error account show in dashboard", error);
    }
  };

  // this function use for close button in MAIN MODAL Dashboard start

  useEffect(() => {
    showRiskLevelCalculation_forSelectedAccount();
  }, [Accountid]);

  // this function checking for 1st account have balance or not
  const showRiskLevelCalculation_forSelectedAccount = async () => {
    // alert('hi')
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-List/${userDetails.id}/${Accountid}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
// console.log("setRiskManagementModal",response?.data?.response.length>0);

      if (response?.data?.response.length != "") {
        // setRiskManagementModal(false);

        setCloseModal(true);
      }
      else if (response?.data?.response.length>0){
        setCloseModal(false);
      }

      // Handle response data as needed
    } catch (error) {
      // setRiskManagementModal(true);
      // console.log("error get-all-risk-level for 1st account", error);
    }
  };

  // Selected account details wise api call
  const showRiskLevelCalculation = async () => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/get-all-RiskLevel-List/${userDetails.id}/${selectedAccountDetails.accountId}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("response get-all-risk-level", response?.data?.response[0]);
      // console.log("response get-all-risk-level", response);
      if (response?.data?.response.length != "") {
        if (accountPriority == "update") {
          setRiskManagementModal(true);
        } else {
          setRiskManagementModal(false);
        }
        // setRiskManagementModal(false);
        setShowModal(false);
        // setRiskManagementModal(false);
      } else if (response?.data?.response.length === 0) {
        setShowModal(false);
        setRiskManagementModal(true);
        dispatch(cancelRiskLevelData());
        dispatch(storeRiskLevel1(null));
        dispatch(storeRiskLevel2(null));
        dispatch(storeRiskLevel3(null));
      }
setShowModal(false);
      // Handle response data as needed
    } catch (error) {
      // setRiskManagementModal(true);
      setShowModal(false);
    }
  };

  useEffect(() => {
    showuserconnectedAccounts();
  }, [selectedAccountDetails?.accountId]);

  // this function call for show all balance selected source_account wise
  const showuserconnectedAccounts = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-all-sourcebase-userconnected-account/${selectedAccountDetails?.accountId}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(getBalance(response.data.response));

      // console.log("showuserconnectedAccounts:", response.data.response);

      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  const AccountStatusforprotectedroutes = async (accountid) => {
    // console.log("accountid protected routes using values for accounts id",accountid)
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-source-account-by-sourceid/${userDetails.id}/${accountid}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("protected routes using values for account id status",response.data.response.status);
      dispatch(addAccountStatus(response.data.response.status));
      // addAccountStatus
      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };

  //  this section for use Account have balance and not start
  // ==========#########========

  const [account_status, setAccount_status] = useState();
  useEffect(() => {
    AccountStatus();
  }, [selectedAccountDetails?.accountId]);

  const AccountStatus = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-source-account-by-sourceid/${userDetails.id}/${selectedAccountDetails?.accountId}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("get-source-account-by-sourceid status",response.data.response.status);
      setAccount_status(response.data.response.status);

      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };
  // ==========#########========
  //  this section for use Account have balance and not start

  // useEffect(()=>{
  //   if(!account_status){
  //     dispatch(storeRiskLevel1(null));
  //       dispatch(storeRiskLevel2(null));
  //       dispatch(storeRiskLevel3(null));
  //   }
  // },[account_status]);

  const expID = CalculationResponse?.experienceId;
  // console.log("expID==>", expID);
  const aggressiveDRPTBalance = CalculationResponse?.aggressiveDRPT;
  const [experienceid, setExperineceId] = useState();

  useEffect(() => {
    ShowMoneyManagement();
    setExperineceId(expID);
    consistencyProfitable()
    //  setExperineceId(CalculationResponse?.experienceId);
  }, [selectedAccountDetails?.accountId, expID, aggressiveDRPTBalance, ]);

  const [AggressiveData,setAggressiveData]=useState();
  const [NeutralData,setNeutralData]=useState();
  const [ConservativeData,setConservativeData]=useState();
// new changes only reflect all  data if user consistency profitable start
const consistencyProfitable = async () => {
  
  setShowModal(true);

  try {
    const response = await axios.get(
      `${APi_Url}api/RiskLevelCalculation/Get-money-management-calculation-By-Filter/${userDetails.id}/${selectedAccountDetails?.accountId}/${'All'}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // console.log("consistencyProfitable", response);
    if(response?.data?.statusCode==200 &&response?.data?.success==true){

    setAggressiveData(
      response?.data?.response.filter((item) => item.maxDDAmount === CalculationResponse?.aggressiveDRPT)
    );
    setConservativeData(  response?.data?.response.filter((item) => item.maxDDAmount === CalculationResponse?.conservativeDRPT));
    setNeutralData(  response?.data?.response.filter((item) => item.maxDDAmount === CalculationResponse?.neutralDRPT));
  }
    setShowModal(false);
  } catch (error) {
    console.error("Error ", error);
 setShowModal(false);
  }
};






// new changes only reflect all  data if user consistency profitabl start






  // Money Management Data Calcul

  // moneymanagementData store
  const [moneymanagementData, setMoneyManagementData] = useState([]);

  // drawdown balance store
  const [drawDown, setDrawDown] = useState([]);

  // start moneymanagement function call
  const FilterMoneyManagementforchecking = async (filterData) => {
    console.log("filterData",filterData);
    setShowModal(true);

    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/Get-money-management-calculation-By-Filter/${userDetails.id}/${selectedAccountDetails?.accountId}/${filterData}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("money managemt filter api", response.data);

      // setMoneyManagementData(response.data?.response);
      // drawdown balance
      setShowModal(false);
      return response.data.response;

      // setShowModal(false);
    } catch (error) {
      console.error("Error ", error);
      setShowModal(false);
      // setShowModal(false);
    }
  };

  const ShowMoneyManagement = async () => {
    setShowModal(true);

    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/money-management-calculation/${userDetails.id}/${selectedAccountDetails?.accountId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("Full response data:", response.data?.response);
      const moneyManagementData =
        response.data?.response?.moneyManagementCalculations;
      // console.log("Money Management Calculations:", moneyManagementData);

      if (moneyManagementData?.length > 0) {
        setMoneyManagementData(
          response.data?.response?.moneyManagementCalculations
        );
      } else if (
        CalculationResponse?.experienceId == 1 &&
        CalculationResponse?.nurtalCoefficient > 0
      ) {
        const data = await FilterMoneyManagementforchecking(
          CalculationResponse?.neutralDRPT
        );

        setMoneyManagementData(data);
      } else if (
        CalculationResponse?.experienceId == 1 &&
        CalculationResponse?.aggressiveCoefficient > 0
      ) {
        const data = await FilterMoneyManagementforchecking(
          CalculationResponse?.aggressiveDRPT
        );

        setMoneyManagementData(data);
      } else if (
        CalculationResponse?.experienceId == 2 &&
        CalculationResponse?.nurtalCoefficient > 0
      ) {
        const data = await FilterMoneyManagementforchecking(
          CalculationResponse?.neutralDRPT
        );

        setMoneyManagementData(data);
      } else if (
        CalculationResponse?.experienceId == 2 &&
        CalculationResponse?.conservativeCoefficient > 0
      ) {
        const data = await FilterMoneyManagementforchecking(
          CalculationResponse?.conservativeDRPT
        );

        setMoneyManagementData(data);
      }

      // drawdown balance
      setDrawDown(response.data?.response?.drawDown);
      setShowModal(false);
    } catch (error) {
      console.error("Error ", error);
      setMoneyManagementData("");
      setDrawDown("");
      setShowModal(false);
    }
  };

  // Below section for current balance and peak balnace submit, edit, display ad avalidation start
  // ------------+++++++++++-------------

  const [currentBalancestate, setCurrentBalancestate] = useState(false);
  const [edit_cBalancestate, setEdit_CBalancestate] = useState(false);
  const [currentBalance, setCurrentBalance] = useState(0);
  const [submittedcurrentBalance, setSubmittedCurrentBalance] = useState(0);
  const [currentBalanceerror, setCurrentBalanceError] = useState("");
  const [cbuserConnectedAccountId, setCbuserConnectedAccountId] = useState();

  const [peackBalancestate, setPeackBalancestate] = useState(false);
  const [edit_pBalancestate, setEdit_PBalancestate] = useState(false);
  const [peakBalance, setPeakBalance] = useState(0);
  const [submittedpeakBalance, setSubmittedPeakBalance] = useState(0);
  const [peakBalanceerror, setPeakBalanceError] = useState("");
  const [pbuserConnectedAccountId, setPbuserConnectedAccountId] = useState();

  const [traillingBalancestate, setTraillingBalancestate] = useState(false);
  const [edit_tBalancestate, setEdit_TBalancestate] = useState(false);
  const [traillingBalance, setTraillingBalance] = useState();
  const [submittedtraillingBalance, setSubmittedTraillingBalance] =
    useState("");
  const [traillingBalanceerror, settraillingBalanceError] = useState("");
  const [tbuserConnectedAccountId, setTbuserConnectedAccountId] = useState();

  const currentBalanceAccountId = 1;
  const peakBalanceAccountId = 2;
  const traillingBalanceAccountId = 3;

  useEffect(() => {
    let hasCurrentBalance = false;
    let hasPeakBalance = false;
    let hasTraillingBalance = false;

    if (getBalanceDetails?.length > 0) {
      getBalanceDetails.forEach((detail) => {
        switch (detail.amountTypeid) {
          case 1:
            hasCurrentBalance = true;
            setCurrentBalancestate(detail.balance ? true : false);
            setCurrentBalance(detail.balance);
            setSubmittedCurrentBalance(detail.balance);
            setCbuserConnectedAccountId(detail.userConnectedAccountId);
            break;
          case 2:
            hasPeakBalance = true;
            setPeackBalancestate(detail.balance ? true : false);
            setPeakBalance(detail.balance);
            setSubmittedPeakBalance(detail.balance);
            setPbuserConnectedAccountId(detail.userConnectedAccountId);
            break;
          case 3:
            hasTraillingBalance = true;
            setTraillingBalancestate(detail.balance ? true : false);
            setTraillingBalance(detail.balance);
            setSubmittedTraillingBalance(detail.balance);
            setTbuserConnectedAccountId(detail.userConnectedAccountId);
            break;
          default:
            break;
        }
      });

      if (!hasCurrentBalance) {
        // Handle previous data or set default values for current balance
        setCurrentBalancestate(false);
        setCurrentBalance(); // Keep previous data or set default
        setSubmittedCurrentBalance(); // Keep previous data or set default
        setCbuserConnectedAccountId(); // Keep previous data or set default
      }

      if (!hasPeakBalance) {
        // Handle previous data or set default values for peak balance
        setPeackBalancestate(false);
        setPeakBalance(); // Keep previous data or set default
        setSubmittedPeakBalance(); // Keep previous data or set default
        setPbuserConnectedAccountId(); // Keep previous data or set default
      }

      if (!hasTraillingBalance) {
        // Handle previous data or set default values for trailing balance
        setTraillingBalancestate(false);
        setTraillingBalance(); // Keep previous data or set default
        setSubmittedTraillingBalance(); // Keep previous data or set default
        setTbuserConnectedAccountId(); // Keep previous data or set default
      }
    } else {
      // Handle case when getBalanceDetails is empty or undefined
      setCurrentBalancestate(false);
      setPeackBalancestate(false);
      setTraillingBalancestate(false);
      setCurrentBalance();
      setPeakBalance();
      setTraillingBalance();
      setSubmittedCurrentBalance();
      setSubmittedPeakBalance();
      setSubmittedTraillingBalance();
      setCbuserConnectedAccountId();
    }
  }, [getBalanceDetails]);
  // checking current balance
  //   useEffect(() => {
  //     // Check if all relevant data is available before proceeding
  //     if (drawDown?.liqThreshold !== undefined && submittedcurrentBalance !== undefined) {
  //         console.log("outside if drawDown?.liqThreshold", drawDown?.liqThreshold, submittedcurrentBalance);

  //         if (Number(drawDown?.liqThreshold) > Number(submittedcurrentBalance)) {
  //             console.log("yes drawDown?.liqThreshold", drawDown?.liqThreshold, submittedcurrentBalance);
  //             toast.error("Please update your current balance");
  //             EditCBFunction(currentBalanceAccountId, 0, cbuserConnectedAccountId);
  //         } else if (Number(submittedcurrentBalance) > Number(submittedpeakBalance)) {
  //             toast.error("Please update your current balance");
  //             EditCBFunction(currentBalanceAccountId, 0, cbuserConnectedAccountId);
  //         }
  //     }
  // }, [submittedcurrentBalance, drawDown?.liqThreshold, submittedpeakBalance]);

  useEffect(() => {
    // Set a debounce timer to delay the execution of the logic
    const timer = setTimeout(() => {
      // Ensure both values are properly set and valid before running any logic
      if (
        drawDown?.liqThreshold !== undefined &&
        drawDown?.liqThreshold > 0 && // Ensure a positive threshold
        submittedcurrentBalance !== undefined &&
        submittedcurrentBalance >= 0 // Ensure the balance is valid
      ) {
        // console.log("outside if drawDown?.liqThreshold", drawDown?.liqThreshold, submittedcurrentBalance);

        // Check if the liquidity threshold is greater than the current balance
        if (Number(drawDown?.liqThreshold) > Number(submittedcurrentBalance)) {
          // console.log("yes drawDown?.liqThreshold", drawDown?.liqThreshold, submittedcurrentBalance);
          toast.error("Please update your current balance");
          EditCBFunction(currentBalanceAccountId, 0, cbuserConnectedAccountId);
        }
        // Check if the current balance is greater than the peak balance
        else if (
          Number(submittedcurrentBalance) > Number(submittedpeakBalance)
        ) {
          toast.error("Please update your current balance");
          EditCBFunction(currentBalanceAccountId, 0, cbuserConnectedAccountId);
        }
      }
    }, 800); // 800ms debounce timer (adjust as necessary)

    // Cleanup the timer on component unmount or before next effect
    return () => clearTimeout(timer);
  }, [submittedcurrentBalance, drawDown?.liqThreshold, submittedpeakBalance]); // Re-run when dependencies change

  // this function call edit current balance
  const EditCBFunction = async (balanceaccountid, edit_balance, userCon_id) => {
    const data = {
      uid: userDetails.id, //login user id
      userConnectedAccountId: userCon_id, //seleceted account id
      accountid: selectedAccountDetails?.accountId,
      balance: edit_balance?.toString(),
      amountTypeid: balanceaccountid,
      createdDate: createdDate,
      createdBy: userDetails.id,
      deletedDate: createdDate,
      deletedBy: 0,
      updatedDate: createdDate,
      updatedBy: 0,
    };

    try {
      const response = await axios.post(
        `${APi_Url}api/account/update-user-connected-account`,
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      showuserconnectedAccounts();
      // console.log("Response currentbalance:", response);
      // toast.success("Successfully Edit balance");
      ShowMoneyManagement();
      // "#accountModal".modal("hide");
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // this function call all balance edit function balance name wise
  const allEditFunction = async (
    balanceaccountid,
    edit_balance,
    userCon_id
  ) => {
    const data = {
      uid: userDetails.id, //login user id
      userConnectedAccountId: userCon_id, //seleceted account id
      accountid: selectedAccountDetails?.accountId,
      balance: edit_balance?.toString(),
      amountTypeid: balanceaccountid,
      createdDate: createdDate,
      createdBy: userDetails.id,
      deletedDate: createdDate,
      deletedBy: 0,
      updatedDate: createdDate,
      updatedBy: 0,
    };

    try {
      const response = await axios.post(
        `${APi_Url}api/account/update-user-connected-account`,
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      showuserconnectedAccounts();
      console.log("Response currentbalance:", response);
      toast.success("Successfully Edit balance");
      ShowMoneyManagement();
      // "#accountModal".modal("hide");
      // Handle response data as needed
    } catch (error) {
      console.error("Error ", error);
    }
  };

  // this is handle edit function for current balance
  const handleeditCurrentBalane = async () => {
    if (currentBalance?.trim() === "") {
      setCurrentBalanceError("Please enter a value");
    } else {
      setCurrentBalanceError(""); // Clear any existing error

      const peakBalanceNum = parseFloat(submittedpeakBalance);
      const currentBalanceNum = parseFloat(currentBalance);

      // if (isNaN(peakBalanceNum) || isNaN(currentBalanceNum)) {
      //   toast.error("Please enter valid numeric values");
      // }
      // else

      if (!peakBalanceNum) {
        allEditFunction(
          currentBalanceAccountId,
          currentBalance,
          cbuserConnectedAccountId
        );
        setEdit_CBalancestate(false);
      } else {
        if (currentBalanceNum > peakBalanceNum) {
          // isDeleted: true,

          toast.error("Please enter a value less than the peak balance");
        } else if (currentBalanceNum <= drawDown?.liqThreshold) {
          toast.error("Please enter greater than liqThreshold value");
        } else {
          allEditFunction(
            currentBalanceAccountId,
            currentBalance,
            cbuserConnectedAccountId
          );
          setEdit_CBalancestate(false);
        }
      }
    }
  };

  // this is handle edit function for peak balance
  const handleeditPeakBalane = async () => {
    if (peakBalance?.trim() === "") {
      setPeakBalanceError("Please enter a value");
    } else {
      setPeakBalanceError(""); // Clear any existing error
      const peakBalanceNum = parseFloat(peakBalance);
      const currentBalanceNum = parseFloat(submittedcurrentBalance);

      // if (isNaN(peakBalanceNum) || isNaN(currentBalanceNum)) {
      //   toast.error("Please enter valid numeric values");
      // }
      //  else if (submittedcurrentBalance >= peakBalanceNum) {
      //   toast.error("Please enter a value greater than the current balance");
      // }
      //  else {
      // isDeleted: true,
      allEditFunction(
        peakBalanceAccountId,
        peakBalance,
        pbuserConnectedAccountId
      );
      setEdit_PBalancestate(false);
    }
  };

  // this is handle edit function for trailling balance
  const handleeditTraillingBalance = async () => {
    if (traillingBalance?.trim() === "") {
      settraillingBalanceError("Please enter a value");
    } else {
      settraillingBalanceError(""); // Clear any existing error

      // isDeleted: true,
      // console.log("trailling balance edit",cbuserConnectedAccountId)
      allEditFunction(
        traillingBalanceAccountId,
        traillingBalance,
        tbuserConnectedAccountId
      );
      setEdit_TBalancestate(false);
    }
  };

  // this is onclick submit function for current balance, when user click the submit icon

  const handleSubmitCurrentBalane = async () => {
    if (!selectedAccountDetails) {
      toast.error("Please create account");
    } else {
      if (!currentBalance || currentBalance.trim() === "") {
        setCurrentBalanceError("Please enter a value");
      } else if (Number(currentBalance) > Number(submittedpeakBalance)) {
        toast.error("Please enter less than peakBalance value");
      } else if (Number(currentBalance) <= Number(drawDown?.liqThreshold)) {
        toast.error("Please enter greater than liqThreshold value");
      } else {
        setCurrentBalanceError(""); // Clear any existing error
        const data = {
          uid: userDetails.id, //login user id
          accountid: selectedAccountDetails?.accountId, //seleceted account id
          balance: currentBalance?.toString(),
          amountTypeid: 1,
          createdDate: createdDate,
          createdBy: userDetails.id,
          deletedDate: createdDate,
          deletedBy: 0,
          updatedDate: createdDate,
          updatedBy: 0,
        };
        // isDeleted: true,
        // alert("yes")
        try {
          const response = await axios.post(
            `${APi_Url}api/account/create-user-connected-account`,
            data,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          showuserconnectedAccounts();
          // console.log("Response currentbalance:", response);
          toast.success("Successfully Submit Current Balance");
        } catch (error) {
          console.error("Error ", error);
        }
      }
    }
  };

  // this is handle key function for current balance, when user enter on input field
  const handleKeyPressCurrentBalance = (e) => {
    if (!currentBalance || currentBalance.trim() === "") {
      setCurrentBalanceError("Please enter a value");
    } else {
      if (e.key === "Enter" && submittedcurrentBalance) {
        const peakBalanceNum = parseFloat(peakBalance);
        const currentBalanceNum = parseFloat(currentBalance);

        console.log("peakBalanceNum", peakBalance);

        if (!peakBalanceNum) {
          handleeditCurrentBalane();
        } else {
          if (currentBalanceNum < peakBalanceNum) {
            handleeditCurrentBalane();
          } else {
            toast.error("Please enter a value less than the peak balance");
          }
        }

        // handleeditCurrentBalane();
      } else if (e.key === "Enter") {
        handleSubmitCurrentBalane();
      }

      setCurrentBalanceError(""); // Clear any existing error
    }
  };

  // this is onclick submit function for peak balance, when user click the submit icon

  const handleSubmitPeakBalane = async () => {
    if (!selectedAccountDetails) {
      toast.error("Please create account");
    } else {
      if (!peakBalance || peakBalance.trim() === "") {
        setPeakBalanceError("Please enter a value");
      }
      //  else {
      //   const peakBalanceNum = parseFloat(peakBalance);
      //   const currentBalanceNum = parseFloat(currentBalance);
      //   console.log("currentBalanceNum",currentBalance);
      //   console.log("peakBalanceNum",peakBalanceNum);
      //   if (isNaN(peakBalanceNum) || isNaN(currentBalanceNum)) {
      //     toast.error("Please enter valid numeric values");
      //   } else if (peakBalanceNum <= currentBalanceNum) {
      //     toast.error("Please enter a value greater than the current balance");
      //   }
      else {
        const data = {
          uid: userDetails.id,
          accountid: selectedAccountDetails?.accountId,
          balance: peakBalance?.toString(),
          amountTypeid: 2,
          createdDate: createdDate,
          createdBy: userDetails.id,
          deletedDate: createdDate,
          deletedBy: 0,
          updatedDate: createdDate,
          updatedBy: 0,
        };

        try {
          const response = await axios.post(
            `${APi_Url}api/account/create-user-connected-account`,
            data,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          showuserconnectedAccounts();
          // console.log("Response peakBalance:", response);
          toast.success("Successfully Submit Peak balance");
          ShowMoneyManagement();
        } catch (error) {
          console.error("Error ", error);
        }
        // }

        setPeakBalanceError(""); // Clear any existing error
      }
    }
  };

  // this is handle key function for peak balance, when user enter on input field
  const handleKeyPress = (e) => {
    if (!peakBalance || peakBalance.trim() === "") {
      setPeakBalanceError("Please enter a value");
    } else {
      if (e.key === "Enter" && submittedpeakBalance) {
        const peakBalanceNum = parseFloat(peakBalance);
        const currentBalanceNum = parseFloat(submittedcurrentBalance);

        // if (isNaN(peakBalanceNum) || isNaN(currentBalanceNum)) {
        //   toast.error("Please enter valid numeric values");
        // }
        //  else if (submittedcurrentBalance > peakBalanceNum) {
        //   toast.error("Please enter a value greater than the current balance");
        // }
        //  else {
        handleeditPeakBalane();
        // }
      } else if (e.key === "Enter") {
        handleSubmitPeakBalane();
      }

      setPeakBalanceError(""); // Clear any existing error
    }
  };

  // this is onclick submit function for trailling balance, when user click the submit icon
  const handleSubmitTraillingBalane = async () => {
    if (!selectedAccountDetails) {
      toast.error("Please create account");
    } else {
      if (traillingBalance?.trim() === "") {
        settraillingBalanceError("Please enter a value");
      } else {
        settraillingBalanceError(""); // Clear any existing error

        const data = {
          uid: userDetails.id,
          accountid: selectedAccountDetails.accountId,
          balance: traillingBalance.toString(),
          amountTypeid: 3,
          createdDate: createdDate,
          createdBy: userDetails.id,
          deletedDate: createdDate,
          deletedBy: 0,
          updatedDate: createdDate,
          updatedBy: 0,
        };

        try {
          const response = await axios.post(
            `${APi_Url}api/account/create-user-connected-account`,
            data,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          showuserconnectedAccounts();
          // console.log("Response peakBalance:", response);
          toast.success("Successfully Submit Trailling balance");
        } catch (error) {
          console.error("Error ", error);
        }
      }
    }
  };
  // console.log("submittedtraillingBalance",submittedtraillingBalance)
  // this is handle key function for trailling balance, when user enter on input field
  const handleKeyPresstraillingBalance = (e) => {
    if (traillingBalance?.trim() === "") {
      settraillingBalanceError("Please enter a value");
    } else {
      if (e.key === "Enter" && submittedtraillingBalance) {
        handleeditTraillingBalance();
      } else if (e.key === "Enter") {
        handleSubmitTraillingBalane();
      }

      settraillingBalanceError(""); // Clear any existing error
    }
  };

  useEffect(() => {
    if (traillingBalancestate) {
      const inputField = document.querySelector(".trail");

      if (inputField) {
        inputField.focus();
      }
    }
    if (edit_tBalancestate) {
      const inputField = document.querySelector(".trail");

      if (inputField) {
        inputField.focus();
      }
    }
  }, [traillingBalancestate, edit_tBalancestate]);
  useEffect(() => {
    if (currentBalancestate) {
      const inputField = document.querySelector(".current");

      if (inputField) {
        inputField.focus();
      }
    }
    if (edit_cBalancestate) {
      const inputField = document.querySelector(".current");

      if (inputField) {
        inputField.focus();
      }
    }
  }, [currentBalancestate, edit_cBalancestate]);
  useEffect(() => {
    if (peackBalancestate) {
      const inputField = document.querySelector(".peak");

      if (inputField) {
        inputField.focus();
      }
    }
    if (edit_pBalancestate) {
      const inputField = document.querySelector(".peak");

      if (inputField) {
        inputField.focus();
      }
    }
  }, [peackBalancestate, edit_pBalancestate]);
  const today = new Date();
  const createdDate = formatISO(today);

  const peakBalanceStatuchage = () => {
    if (aggressiveDRPTBalance) {
      setPeackBalancestate(!peackBalancestate);
    } else {
      toast.error("Please calculate risk level calculation");
    }
  };
  const currentBalanceStatuchage = () => {
    if (submittedpeakBalance) {
      setCurrentBalancestate(!currentBalancestate);
    } else {
      toast.error("Please enter peak balance");
    }
  };
  // ------------+++++++++++-------------
  // Below section for current balance and peak balnace submit, edit, display ad avalidation  end

  // format number function
  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.abs(number));
  };

  // filter moneyMangement

  const FilterMoneyManagement = async (filterData) => {
    // console.log(filterData);
    setShowModal(true);

    try {
      const response = await axios.get(
        `${APi_Url}api/RiskLevelCalculation/Get-money-management-calculation-By-Filter/${userDetails.id}/${selectedAccountDetails?.accountId}/${filterData}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("money managemt filter api", response.data);

      setMoneyManagementData(response.data?.response);
      // drawdown balance

      setShowModal(false);
    } catch (error) {
      console.error("Error ", error);
      setMoneyManagementData("");

      setShowModal(false);
    }
  };


useEffect(()=>{
    consistencyProfitable()
},[submittedcurrentBalance, drawDown?.liqThreshold])

  const [showAll, setShowAll] = useState(false);

  const displayedData = showAll
    ? moneymanagementData
    : moneymanagementData?.slice(0, 4);

  const handleToggle = () => {
    setShowAll(!showAll);
  };

  // useEffect(() => {
  //   if (experienceid == 2 && CalculationResponse?.aggressiveCoefficient > 0) {
  //     FilterMoneyManagement(CalculationResponse.aggressiveDRPT);
  //   } else if (experienceid == 3 && CalculationResponse?.nurtalCoefficient > 0) {
  //     FilterMoneyManagement(CalculationResponse.neutralDRPT);
  //   } else if (experienceid == 1 && CalculationResponse?.conservativeCoefficient > 0) {
  //     FilterMoneyManagement(CalculationResponse.conservativeDRPT);
  //   } else if (experienceid == 1 && CalculationResponse?.nurtalCoefficient > 0) {
  //     FilterMoneyManagement(CalculationResponse.neutralDRPT);
  //   }
  // }, [experienceid, CalculationResponse]);

  


  return (
    <>
      {/* // <!-- start dashbordsect --> */}
      <section className="dashbordsect">
        <div className="hadformsect">
          <h2>Dashboard</h2>

          <div className="dselectbox">
            {/* <div className="profitbox ">
              <div className="dropflex mb-0">
                <div className="imgboxflex">
                  <span className="icontext">
                    <h4 class="tooltip-target">Profit Factor</h4>
                   
                  </span>
                </div>
              </div>
            </div> */}

            <div className="formslbox">
              <SelectedAccountComponent
                AccountStatus_function={AccountStatus}
                RiskManagementModal={setRiskManagementModal}
                accounts={accounts}
                // Show_MoneyManagement={ShowMoneyManagement}
              />
            </div>
            <div className="datpickbox">
              <img
                src={icon4}
                alt="addicon"
                className="modal_img"
                // data-bs-toggle="modal"
                // data-bs-target="#exampleModal"
                onClick={() => {
                  setRiskManagementModal(true);
                }}
              />
            </div>
            <div className="formslbox" style={{ minWidth: "100px" }}>
              {/* <div className="dropdown">
                <button
                  className="btn dropdown-toggle form-select"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Select Asset
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="#">
                      CL
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="#">
                      MCL
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="#">
                      ES
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="#">
                      MES
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="#">
                      NQ
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="#">
                      MNQ
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="#">
                      YM
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="#">
                      MYM
                    </Link>
                  </li>
                </ul>
              </div> */}
              <SelectedAssetsComponent AccountStatus={account_status} />
            </div>

            {/* <div className="datpickbox">
              <img src={date} alt="date" />
            </div> */}
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="boxflexlist">
              {/* current balance */}
              <div className="whitbox width3">
                {submittedcurrentBalance ? (
                  <div className="addbtn">
                    <div
                      className="edit-symbol"
                      onClick={() => setEdit_CBalancestate(true)}
                    >
                      <MdEdit />
                    </div>
                  </div>
                ) : (
                  <div className="addbtn" onClick={currentBalanceStatuchage}>
                    <img src={addicon} alt="" />
                  </div>
                )}

                <div className="imgbox">
                  <BsCurrencyDollar />
                </div>

                <span className="icontext">
                  <h4 class="tooltip-target">Current Balance</h4>
                  <div className="tooltipico">
                    <div class="tooltip-container">
                      <span className="tooltipsvg">
                        <GoQuestion />
                      </span>
                      <div class="tooltip">
                        The current balance of your trading account. This is
                        either manually input by you, or from your linked
                        trading journal software. (TradeZella connection coming
                        soon)
                      </div>
                    </div>
                  </div>
                </span>

                {currentBalancestate ? (
                  submittedcurrentBalance ? (
                    submittedcurrentBalance && !edit_cBalancestate ? (
                      <div className="balance-group ">
                        <h3>${formatNumber(submittedcurrentBalance)}</h3>
                      </div>
                    ) : (
                      <>
                        {" "}
                        <div className="inputbox">
                          <div className="input-group ">
                            <input
                              type="number"
                              className="form-control current"
                              value={currentBalance}
                              onChange={(e) =>
                                setCurrentBalance(e.target.value)
                              }
                              onKeyPress={handleKeyPressCurrentBalance}
                            />

                            <span
                              className="symbol"
                              onClick={handleeditCurrentBalane}
                            >
                              <MdEdit />
                            </span>
                          </div>
                        </div>
                        {currentBalanceerror && (
                          <div className="error_msg">{currentBalanceerror}</div>
                        )}
                      </>
                    )
                  ) : (
                    <>
                      <div className="inputbox">
                        <div className="input-group ">
                          <input
                            type="number"
                            className="form-control current"
                            value={currentBalance}
                            onChange={(e) => setCurrentBalance(e.target.value)}
                            onKeyPress={handleKeyPressCurrentBalance}
                          />

                          <span
                            className="symbol"
                            onClick={handleSubmitCurrentBalane}
                          >
                            <FaLocationArrow />
                          </span>
                        </div>
                      </div>
                      {currentBalanceerror && (
                        <div className="error_msg">{currentBalanceerror}</div>
                      )}
                    </>
                  )
                ) : (
                  <h3>NA</h3>
                )}
              </div>
              {/* peak balance */}
              <div className="whitbox width3">
                {submittedpeakBalance ? (
                  <div className="addbtn">
                    <div
                      className="edit-symbol"
                      onClick={() => setEdit_PBalancestate(true)}
                    >
                      <MdEdit />
                    </div>
                  </div>
                ) : (
                  <div className="addbtn" onClick={peakBalanceStatuchage}>
                    <img src={addicon} alt="" />
                  </div>
                )}

                <div className="imgbox">
                  <BsGraphUpArrow />
                </div>

                <span className="icontext">
                  <h4 class="tooltip-target">Peak Balance</h4>
                  <div className="tooltipico">
                    <div class="tooltip-container">
                      <span className="tooltipsvg">
                        <GoQuestion />
                      </span>
                      <div class="tooltip">
                        This is your peak balance, or the highest dollar value
                        your account has reached. This is important if you're
                        trading using a prop firm, as your trailing drawdown is
                        often calculated from this, depending on which company
                        you are using. ALWAYS check with your specific company.
                        This is either manually input by you, or from your
                        linked trading journal software. (TradeZella connection
                        coming soon)
                      </div>
                    </div>
                  </div>
                </span>

                {peackBalancestate ? (
                  submittedpeakBalance ? (
                    submittedpeakBalance && !edit_pBalancestate ? (
                      <div className="balance-group ">
                        <h3>${formatNumber(submittedpeakBalance)}</h3>
                      </div>
                    ) : (
                      <>
                        {" "}
                        <div className="inputbox">
                          <div className="input-group ">
                            <input
                              type="number"
                              className="form-control peak"
                              value={peakBalance}
                              onChange={(e) => setPeakBalance(e.target.value)}
                              onKeyPress={handleKeyPress}
                            />

                            <span
                              className="symbol"
                              onClick={handleeditPeakBalane}
                            >
                              <MdEdit />
                            </span>
                          </div>
                        </div>
                        {peakBalanceerror && (
                          <div className="error_msg">{peakBalanceerror}</div>
                        )}
                      </>
                    )
                  ) : (
                    <>
                      <div className="inputbox">
                        <div className="input-group ">
                          <input
                            type="number"
                            className="form-control peak"
                            value={peakBalance}
                            onChange={(e) => setPeakBalance(e.target.value)}
                            onKeyPress={handleKeyPress}
                          />

                          <span
                            className="symbol"
                            onClick={handleSubmitPeakBalane}
                          >
                            <FaLocationArrow />
                          </span>
                        </div>
                      </div>
                      {peakBalanceerror && (
                        <div className="error_msg">{peakBalanceerror}</div>
                      )}
                    </>
                  )
                ) : (
                  <h3>NA</h3>
                )}
              </div>

              {/*Liq Threshold */}
              <div className="whitbox width3">
                {/* <div
                  className="addbtn"
                  onClick={() =>
                    setTraillingBalancestate(!traillingBalancestate)
                  }
                >
                  <img src={addicon} alt="" />
                </div> */}
                <div className="imgbox">
                  {/* <img src={i3} alt="" /> */}
                  <TfiPieChart />
                </div>

                <span className="icontext">
                  <h4 class="tooltip-target">Liq Threshold</h4>
                  <div className="tooltipico">
                    <div class="tooltip-container">
                      <span className="tooltipsvg">
                        <GoQuestion />
                      </span>
                      <div class="tooltip">
                        Your Liq Threshold is the lowest cash value that your
                        account can reach before failing your prop firm
                        evaluation and/or funded account. This is calculated by
                        subtracting your Trailing Drawdown from your Peak
                        Balance, but always make sure to check with your
                        specific funding company to confirm their rules.
                      </div>
                    </div>
                  </div>
                </span>

                <h3>
                  {drawDown
                    ? drawDown?.liqThreshold != "-"
                      ? drawDown?.liqThreshold < 0
                        ? `-$${formatNumber(drawDown?.liqThreshold)}`
                        : `$${formatNumber(drawDown?.liqThreshold)}`
                      : drawDown?.liqThreshold
                    : "NA"}

                  {/* {`${
                          data.fifty_RLoss < 0 ? "-$" : "$"
                        }${formatNumber(data.fifty_RLoss)}`} */}
                </h3>
              </div>

              {/*trailling Drawdown  */}
              <div className="whitbox width3">
                {/* <div
                  className="addbtn"
                  onClick={() =>
                    setTraillingBalancestate(!traillingBalancestate)
                  }
                >
                  <img src={addicon} alt="" />
                </div> */}
                <div className="imgbox">
                  {/* <img src={i3} alt="" /> */}
                  <GiChart />
                </div>
                <span className="icontext">
                  <h4 class="tooltip-target">Trailing Drawdown</h4>
                  <div className="tooltipico">
                    <div class="tooltip-container">
                      <span className="tooltipsvg">
                        <GoQuestion />
                      </span>
                      <div class="tooltip">
                        Trailing Drawdown is the amount of drawdown you are
                        allowed before failing your evaluation/funded account.
                        Draw down is a peak-to-trough decline during a specific
                        period for a trading account. For example, if your peak
                        balance was $50,000 and your trailing drawdown was
                        $2,500 then your account would be violated if you
                        reached $47,500
                      </div>
                    </div>
                  </div>
                </span>

                <h3>
                  {CalculationResponse
                    ? `$${formatNumber(CalculationResponse?.trailingDrawdown)}`
                    : "NA"}
                </h3>
          
              </div>
              {/* win rate */}
              <div className="whitbox width3">
                <div className="imgbox">
                  {/* <img src={i3} alt="" /> */}
                  <IoTrophyOutline />
                </div>
                <span className="icontext">
                  <h4 class="tooltip-target">Win Rate</h4>
                  <div className="tooltipico">
                    <div class="tooltip-container">
                      <span className="tooltipsvg">
                        <GoQuestion />
                      </span>
                      <div class="tooltip">
                        Win-rate is how many trades you win, usually given as a
                        percentage. Such as 50%, which is 5 wins out of 10
                        trades, or 50 wins out of 100 trades.{" "}
                      </div>
                    </div>
                  </div>
                </span>

                <h3>
                  {CalculationResponse
                    ? CalculationResponse?.winRate * 100 + "%"
                    : "NA"}
                </h3>
                {/* <h3>
                  {CalculationResponse ? CalculationResponse.remainder : "NA"}
                </h3> */}
              </div>
              {/* risk reward */}
              <div className="whitbox width3">
                <div className="imgbox">
                  {/* <img src={i3} alt="" /> */}
                  <RiSketching />
                </div>
                <span className="icontext">
                  <h4 class="tooltip-target">Risk Reward</h4>
                  <div className="tooltipico">
                    <div class="tooltip-container">
                      <span className="tooltipsvg">
                        <GoQuestion />
                      </span>
                      <div class="tooltip tooltipright">
                        The risk/reward ratio—also known as the risk/return
                        ratio—marks the prospective reward an investor can earn
                        for every dollar they risk on an investment.
                      </div>
                    </div>
                  </div>
                </span>

                {/* <h3>
                  {CalculationResponse
                    ? CalculationResponse.allPossibleTriples
                    : "NA"}
                </h3> */}
                <h3>
                  {CalculationResponse ? CalculationResponse?.riskReward : "NA"}
                </h3>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="boxflexlist">
              <div className="whitbox width2">
                <div className="dropflex mb-0">
                  <div className="imgboxflex">
                    <div className="iconcomonbox">
                      {/* <img src={comonicon} alt="" /> */}
                      <RiLineChartFill style={{ fontSize: "21px" }} />
                    </div>
                    <span className="icontext">
                      <h4 class="tooltip-target">Aggressive</h4>
                      <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                            <GoQuestion />
                          </span>
                          <div class="tooltip">
                            The aggressive risk level is the most money you
                            should risk on one trade, based on your personal
                            trading statistics. This is usually used when your
                            account is close to its highest balance. Keep in
                            mind not all traders will be suggested to use all
                            risk levels based on their statistics.
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  {CalculationResponse ? (
                    <h3>${CalculationResponse.aggressiveDRPT}</h3>
                  ) : (
                    <h3> NA</h3>
                  )}
                </div>
              </div>

              {/* neutral */}

              <div className="whitbox width2">
                <div className="dropflex mb-0">
                  <div className="imgboxflex">
                    <div className="iconcomonbox">
                      {/* <img src={comonicon} alt="" /> */}
                      <PiChartLineBold style={{ fontSize: "21px" }} />
                    </div>
                    <span className="icontext">
                      <h4 class="tooltip-target">Neutral</h4>
                      <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                            <GoQuestion />
                          </span>
                          <div class="tooltip">
                            The neutral risk level is a medium amount of money
                            to risk on each trade, based on how well your
                            trading has been going. This is typically used when
                            your account balance is steady, not at its highest
                            or lowest point. Keep in mind not all traders will
                            be suggested to use all risk levels based on their
                            statistics.
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  {CalculationResponse ? (
                    <h3>${CalculationResponse.neutralDRPT}</h3>
                  ) : (
                    <h3> NA</h3>
                  )}
                </div>
              </div>

              <div className="whitbox width2">
                <div className="dropflex mb-0">
                  <div className="imgboxflex">
                    <div className="iconcomonbox">
                      {/* <img src={comonicon} alt="" /> */}
                      <BiLineChartDown style={{ fontSize: "21px" }} />
                    </div>

                    <span className="icontext">
                      <h4 class="tooltip-target">Conservative</h4>
                      <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                            <GoQuestion />
                          </span>
                          <div class="tooltip">
                            The conservative risk level is a small amount of
                            money to risk on each trade, based on your trading
                            statistics. This is usually used when you have been
                            on a losing streak, are close to hitting your
                            trailing drawdown, or are a beginner trader. Keep in
                            mind not all traders will be suggested to use all
                            risk levels based on their statistics.
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>

                  {CalculationResponse ? (
                    <h3>${CalculationResponse.conservativeDRPT}</h3>
                  ) : (
                    <h3> NA</h3>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4 text-center">
            <div className="imgwhitbg">
             
              <Page2 />
            </div>
          </div> */}
          <div className="col-lg-12">
            <div className="acu_tablelistbox ">
              {/* this section for experince id 1 start */}
              {expID == 1 ? (
                CalculationResponse?.conservativeCoefficient == 0 ? (
                  <>
                    <div className="acu_tablelistboxflxb">
                      <h2>
                        Based on Your Trading Statistics This is Your Risk
                        Management Plan
                      </h2>
                      <div className="btnlistflx">
                        <button
                          className="highlightbutton"
                          disabled={
                            CalculationResponse?.conservativeCoefficient == 0
                          }
                        >
                          Conservative
                        </button>
                      </div>
                    </div>

                    <div className="whitbox nodata">
                      <div className="text-center">
                        <h4 className="nodata">
                          {" "}
                          No Data Points Available For
                        </h4>
                        <h5 className="nodata-h5">
                          Trailing Drawdown -
                          {CalculationResponse
                            ? `$${formatNumber(
                                CalculationResponse?.trailingDrawdown
                              )}`
                            : "NA"}
                        </h5>
                        <h5 className="nodata-h5">
                          WinRate -{" "}
                          {CalculationResponse
                            ? CalculationResponse?.winRate * 100 + "%"
                            : "NA"}
                        </h5>
                        <h5 className="nodata-h5">
                          Risk Reward -{" "}
                          {CalculationResponse
                            ? CalculationResponse?.riskReward
                            : "NA"}
                        </h5>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="acu_tablelistboxflxb"
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className="btnlistflx">
                        <button
                          className="highlightbutton"
                          disabled={
                            CalculationResponse?.conservativeCoefficient == 0
                          }
                        >
                          Conservative
                        </button>
                      </div>
                    </div>
                    <div className="acunttablemainbox table-responsive">
                      <table className="table table-borderless mb-0">
                        <thead>
                          <tr>
                            <th scope="col" className="first_th">
                              <span className="icontext">
                                <h4 class="tooltip-target amount-data">
                                  Loss #
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip">
                                      For each losing trade in a streak, move
                                      down to the next number. For example, if
                                      you had lost 3 trades, you would be sizing
                                      positions based off of loss #4.
                                    </div>
                                  </div>
                                </div>
                              </span>

                              {/* <div class="tooltip-container">
                                <p class="tooltip-target">Loss #</p>
                                <div class="tooltip">For each losing trade in a streak, move down to the next number.

For example, if you had lost 3 trades, you would be sizing positions based off of loss #4.</div>
                              </div> */}
                            </th>
                            <th scope="col" className="amount-data">
                              <span className="icontext mlauto">
                                <h4 class="tooltip-target amount-data">
                                  RISK Per Trade
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip">
                                      Risk Per Trade is the MAX amount of risk
                                      that should be placed on any one trade.
                                      Risk is calculated by what the possible
                                      loss could be if the stop loss is hit.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>
                            {/* <th scope="col">50%R loss</th> */}
                            {/* <th scope="col">Cumulative Loss </th> */}
                            <th scope="col" className="amount-data">
                              <span className="icontext mlauto">
                                <h4 class="tooltip-target amount-data">
                                  New Balance
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip tooltipright">
                                      New balance is the account balance after
                                      the loss has been taken.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>
                            {/* <th scope="col">50% R Balance</th> */}
                            {/* <th scope="col">Amt to next R</th> */}
                            {/* <th scope="col">DD Remaining</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {moneymanagementData &&
                            moneymanagementData?.map((data, index) => (
                              <tr>
                                <td scope="col">{index + 1}</td>

                                <td scope="col " className="amount-data">{`${
                                  data.maxDDAmount < 0 ? "-$" : "$"
                                }${formatNumber(data.maxDDAmount)}`}</td>

                                {/* <td scope="col " className="amount-data">{`${
                          data.fifty_RLoss < 0 ? "-$" : "$"
                        }${formatNumber(data.fifty_RLoss)}`}</td> */}
                                {/* <td scope="col " className="amount-data">
                          {`${
                              data.cumulativeLoss < 0 ? "-$" : "$"
                            }${formatNumber(data.cumulativeLoss)}`}{" "}
                        </td> */}
                                <td scope="col " className="amount-data">
                                  {data.maxLossBal != "-"
                                    ? `${
                                        data.maxLossBal < 0 ? "-$" : "$"
                                      }${formatNumber(data.maxLossBal)}`
                                    : data.maxLossBal}
                                </td>
                                {/* <td scope="col " className="amount-data">
                          {data.fifty_Rbal != "-"
                            ? `${
                              data.fifty_Rbal < 0 ? "-$" : "$"
                            }${formatNumber(data.fifty_Rbal)}`
                            : data.fifty_Rbal}
                        </td> */}
                                {/* <td scope="col " className="amount-data">{data.amt_to_next_R!='-'?`$${formatNumber(data.amt_to_next_R)}`:data.amt_to_next_R} </td> */}
                                {/* <td scope="col" className="amount-data">
                          {data.amt_to_next_R !== "-"
                            ? `${
                                data.amt_to_next_R < 0 ? "-$" : "$"
                              }${formatNumber(data.amt_to_next_R)}`
                            : data.amt_to_next_R}
                        </td> */}

                                {/* <td
                          scope="col "
                          className="amount-data"
                        >{`$${formatNumber(data.dD_remaining)}`}</td> */}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )
              ) : null}

              {/* this section for experince id 1 end */}
              {/* this section for experince id 2 start */}
              {/* {CalculationResponse && expID == 2 ? (
                <>
                  <div
                    className="acu_tablelistboxflxb"
                    style={{ justifyContent: "flex-end" }}
                  >
                   
                    <div className="btnlistflx">
                      <button
                        className={
                          experienceid == 2
                            ? CalculationResponse?.aggressiveCoefficient > 0
                              ? "highlightbutton"
                              : "nonhighlighbutton"
                            : experienceid == 1
                            ? CalculationResponse?.conservativeCoefficient > 0
                              ? "nonhighlighbutton"
                              : CalculationResponse?.nurtalCoefficient > 0
                              ? "nonhighlighbutton"
                              : "highlightbutton"
                            : "nonhighlighbutton"
                        }
                        onClick={() => {
                          FilterMoneyManagement(
                            CalculationResponse.aggressiveDRPT
                          );
                          setExperineceId(2);
                          dispatch(submitRisk_level_id(1));
                        }}
                        disabled={
                          CalculationResponse?.aggressiveCoefficient == 0
                        }
                      >
                        Aggressive
                      </button>
                      <button
                        className={
                          experienceid == 3
                            ? "highlightbutton"
                            : experienceid == 2
                            ? CalculationResponse?.aggressiveCoefficient > 0
                              ? "nonhighlighbutton"
                              : CalculationResponse?.nurtalCoefficient > 0
                              ? "highlightbutton"
                              : "nonhighlighbutton"
                            : experienceid == 1
                            ? CalculationResponse?.conservativeCoefficient == 0
                              ? CalculationResponse?.nurtalCoefficient > 0
                                ? "highlightbutton"
                                : "nonhighlighbutton"
                              : "nonhighlighbutton"
                            : "nonhighlighbutton"
                        }
                        onClick={() => {
                          FilterMoneyManagement(
                            CalculationResponse?.neutralDRPT
                          );
                          setExperineceId(3);
                          dispatch(submitRisk_level_id(2));
                        }}
                        disabled={CalculationResponse?.nurtalCoefficient == 0}
                      >
                        Neutral
                      </button>
                      <button
                        className={
                          experienceid == 2
                            ? CalculationResponse?.aggressiveCoefficient > 0
                              ? "nonhighlighbutton"
                              : CalculationResponse?.nurtalCoefficient > 0
                              ? "nonhighlighbutton"
                              : CalculationResponse?.conservativeCoefficient > 0
                              ? " highlightbutton"
                              : " nonhighlighbutton"
                            : experienceid == 1
                            ? CalculationResponse?.conservativeCoefficient > 0
                              ? "highlightbutton"
                              : "nonhighlighbutton"
                            : "nonhighlighbutton"
                        }
                        onClick={() => {
                          FilterMoneyManagement(
                            CalculationResponse?.conservativeDRPT
                          );
                          setExperineceId(1);
                          dispatch(submitRisk_level_id(3));
                        }}
                        disabled={
                          CalculationResponse?.conservativeCoefficient == 0
                        }
                      >
                        Conservative
                      </button>
                    </div>
                  </div>
                  <div className="acunttablemainbox table-responsive">
                    <table className="table table-borderless mb-0">
                      <thead>
                        <tr>
                          <th scope="col" className="first_th">
                            <span className="icontext">
                              <h4 class="tooltip-target amount-data">Loss # <span
                      className="shotricon"
                     
                    >
                      <img src={tblarrrow} alt="tblarrrow" />
                    </span></h4>
                              <div className="tooltipico">
                                <div class="tooltip-container">
                                  <span className="tooltipsvg">
                                    <GoQuestion />
                                  </span>
                                  <div class="tooltip">
                                    For each losing trade in a streak, move down
                                    to the next number. For example, if you had
                                    lost 3 trades, you would be sizing positions
                                    based off of loss #4.
                                  </div>
                                </div>
                              </div>
                            </span>
                          </th>
                          <th scope="col" className="amount-data">
                            <span className="icontext mlauto">
                              <h4 class="tooltip-target amount-data">
                                RISK Per Trade
                              </h4>
                              <div className="tooltipico">
                                <div class="tooltip-container">
                                  <span className="tooltipsvg">
                                    <GoQuestion />
                                  </span>
                                  <div class="tooltip">
                                    Risk Per Trade is the MAX amount of risk
                                    that should be placed on any one trade. Risk
                                    is calculated by what the possible loss
                                    could be if the stop loss is hit.
                                  </div>
                                </div>
                              </div>
                            </span>
                          </th>
                        
                          <th scope="col" className="amount-data">
                          <span className="icontext mlauto">
                              <h4 class="tooltip-target amount-data">
                                New Balance
                              </h4>
                              <div className="tooltipico">
                                <div class="tooltip-container">
                                  <span className="tooltipsvg">
                                    <GoQuestion />
                                  </span>
                                  <div class="tooltip tooltipright">
                                  New balance is the account balance after the loss has been taken.
                                  </div>
                                </div>
                              </div>
                            </span>
                           
                          </th>
                   
                        </tr>
                      </thead>
                      <tbody>
                        {moneymanagementData &&
                          moneymanagementData?.map((data, index) => (
                            <tr>
                              <td scope="col">{index + 1}</td>

                              <td scope="col " className="amount-data">{`${
                                data.maxDDAmount < 0 ? "-$" : "$"
                              }${formatNumber(data.maxDDAmount)}`}</td>

                             
                              <td scope="col " className="amount-data">
                                {data.maxLossBal != "-"
                                  ? `${
                                      data.maxLossBal < 0 ? "-$" : "$"
                                    }${formatNumber(data.maxLossBal)}`
                                  : data.maxLossBal}
                              </td>
                          
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    
                  </div>
                </>
              ) : (
                ""
              )} */}

             {CalculationResponse && expID == 2 ? (
                <>
                {/* Aggressive */}
                 {AggressiveData?.length>0? <div className="acu_tablelistbox mtopminus" style={{marginTop:'15px'}}>
                    <div className="acuntheading">
                      Aggressive {" "}
                      {CalculationResponse
          ? `$${formatNumber(CalculationResponse?.aggressiveDRPT)}`
          : "Na"}
                    </div>
                    <div className="acunttablemainbox table-responsive">
                      <table className="table table-borderless mb-0">
                        <thead>
                          <tr>
                            <th scope="col" className="first_th">
                              <span className="icontext">
                                <h4 class="tooltip-target amount-data">
                                  Loss #{" "}
                                  <span className="shotricon">
                                    <img src={tblarrrow} alt="tblarrrow" />
                                  </span>
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip">
                                      For each losing trade in a streak, move
                                      down to the next number. For example, if
                                      you had lost 3 trades, you would be sizing
                                      positions based off of loss #4.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>
                            <th scope="col" className="amount-data">
                              <span className="icontext mlauto">
                                <h4 class="tooltip-target amount-data">
                                  RISK Per Trade
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip">
                                      Risk Per Trade is the MAX amount of risk
                                      that should be placed on any one trade.
                                      Risk is calculated by what the possible
                                      loss could be if the stop loss is hit.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>

                            <th scope="col" className="amount-data">
                              <span className="icontext mlauto">
                                <h4 class="tooltip-target amount-data">
                                  New Balance
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip tooltipright">
                                      New balance is the account balance after
                                      the loss has been taken.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                        {AggressiveData &&
                          AggressiveData?.map((data, index) => (
                            <tr>
                              <td scope="col">{index + 1}</td>

                              <td scope="col " className="amount-data">{`${
                                data.maxDDAmount < 0 ? "-$" : "$"
                              }${formatNumber(data.maxDDAmount)}`}</td>

                             
                              <td scope="col " className="amount-data">
                                {data.maxLossBal != "-"
                                  ? `${
                                      data.maxLossBal < 0 ? "-$" : "$"
                                    }${formatNumber(data.maxLossBal)}`
                                  : data.maxLossBal}
                              </td>
                          
                            </tr>
                          ))}
                      </tbody>
                      </table>
                    </div>
                  </div>:null}


                  {/* Neutral */}
                  {NeutralData?.length>0? <div className="acu_tablelistbox mtopminus" style={{marginTop:'15px'}}>
                    <div className="acuntheading">
                      Neutral {" "}
                      {CalculationResponse
          ? `$${formatNumber(CalculationResponse?.neutralDRPT)}`
          : "Na"}
                    </div>
                    <div className="acunttablemainbox table-responsive">
                      <table className="table table-borderless mb-0">
                        <thead>
                          <tr>
                            <th scope="col" className="first_th">
                              <span className="icontext">
                                <h4 class="tooltip-target amount-data">
                                  Loss #{" "}
                                  <span className="shotricon">
                                    <img src={tblarrrow} alt="tblarrrow" />
                                  </span>
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip">
                                      For each losing trade in a streak, move
                                      down to the next number. For example, if
                                      you had lost 3 trades, you would be sizing
                                      positions based off of loss #4.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>
                            <th scope="col" className="amount-data">
                              <span className="icontext mlauto">
                                <h4 class="tooltip-target amount-data">
                                  RISK Per Trade
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip">
                                      Risk Per Trade is the MAX amount of risk
                                      that should be placed on any one trade.
                                      Risk is calculated by what the possible
                                      loss could be if the stop loss is hit.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>

                            <th scope="col" className="amount-data">
                              <span className="icontext mlauto">
                                <h4 class="tooltip-target amount-data">
                                  New Balance
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip tooltipright">
                                      New balance is the account balance after
                                      the loss has been taken.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                        {NeutralData &&
                          NeutralData?.map((data, index) => (
                            <tr>
                              <td scope="col">{AggressiveData?.length +index + 1}</td>

                              <td scope="col " className="amount-data">{`${
                                data.maxDDAmount < 0 ? "-$" : "$"
                              }${formatNumber(data.maxDDAmount)}`}</td>

                             
                              <td scope="col " className="amount-data">
                                {data.maxLossBal != "-"
                                  ? `${
                                      data.maxLossBal < 0 ? "-$" : "$"
                                    }${formatNumber(data.maxLossBal)}`
                                  : data.maxLossBal}
                              </td>
                          
                            </tr>
                          ))}
                      </tbody>
                      </table>
                    </div>
                  </div>:null}




                   {/* Conservative */}
                   {ConservativeData?.length>0? <div className="acu_tablelistbox mtopminus" style={{marginTop:'15px'}}>
                    <div className="acuntheading">
                      Conservative {" "}
                      {CalculationResponse
          ? `$${formatNumber(CalculationResponse?.conservativeDRPT)}`
          : "Na"}
                    </div>
                    <div className="acunttablemainbox table-responsive">
                      <table className="table table-borderless mb-0">
                        <thead>
                          <tr>
                            <th scope="col" className="first_th">
                              <span className="icontext">
                                <h4 class="tooltip-target amount-data">
                                  Loss #{" "}
                                  <span className="shotricon">
                                    <img src={tblarrrow} alt="tblarrrow" />
                                  </span>
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip">
                                      For each losing trade in a streak, move
                                      down to the next number. For example, if
                                      you had lost 3 trades, you would be sizing
                                      positions based off of loss #4.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>
                            <th scope="col" className="amount-data">
                              <span className="icontext mlauto">
                                <h4 class="tooltip-target amount-data">
                                  RISK Per Trade
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip">
                                      Risk Per Trade is the MAX amount of risk
                                      that should be placed on any one trade.
                                      Risk is calculated by what the possible
                                      loss could be if the stop loss is hit.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>

                            <th scope="col" className="amount-data">
                              <span className="icontext mlauto">
                                <h4 class="tooltip-target amount-data">
                                  New Balance
                                </h4>
                                <div className="tooltipico">
                                  <div class="tooltip-container">
                                    <span className="tooltipsvg">
                                      <GoQuestion />
                                    </span>
                                    <div class="tooltip tooltipright">
                                      New balance is the account balance after
                                      the loss has been taken.
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                        {ConservativeData &&
                          ConservativeData?.map((data, index) => (
                            <tr>
                              <td scope="col">{AggressiveData?.length+ NeutralData?.length+ index + 1}</td>

                              <td scope="col " className="amount-data">{`${
                                data.maxDDAmount < 0 ? "-$" : "$"
                              }${formatNumber(data.maxDDAmount)}`}</td>

                             
                              <td scope="col " className="amount-data">
                                {data.maxLossBal != "-"
                                  ? `${
                                      data.maxLossBal < 0 ? "-$" : "$"
                                    }${formatNumber(data.maxLossBal)}`
                                  : data.maxLossBal}
                              </td>
                          
                            </tr>
                          ))}
                      </tbody>
                      </table>
                    </div>
                  </div>:null}
                </>
              ) : null} 
            </div>
          </div>
          <div className="col-lg-12">
            <AssetCalcualtion />
          </div>
        </div>
      </section>

      {/* For modal */}

      <div
        className={`modal fade inputmodal ${riskManagementModal ? "show" : ""}`}
        aria-hidden="true"
        style={{ display: riskManagementModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1>Inputs</h1>
            </div>
            <div className="modal-body">
              <ModalFrom
                setmodalStatus={setRiskManagementModal}
                modalStatus={closeModal}
                AccountStatus_function={AccountStatus}
                modalStatus_function={
                  showRiskLevelCalculation_forSelectedAccount
                }
                AccountsStatus_Firstvalue={showAccounts_dashboard}
                MoneyManagement_show={ShowMoneyManagement}
                setExperinece_Id={setExperineceId}
                LoaderModal={setShowModal}
              />
            </div>
          </div>
        </div>
      </div>
      <LoaderModal show={showModal} />
    </>
  );
};

export default Dashboard;
